export default function Industries() {
  const industries = [
    {
      icon: 'ri-heart-pulse-line',
      name: 'Healthcare',
      description: 'AI systems that reduce administrative burden, improve scheduling flow, and support compliance-sensitive environments.',
      image: 'https://public.readdy.ai/ai/img_res/ad4e7be7c1493b250c9069b6712aaa46.jpg'
    },
    {
      icon: 'ri-line-chart-line',
      name: 'Financial Services',
      description: 'Risk-aware intelligence systems that enhance reporting, forecasting, and operational oversight.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20services%20office%20with%20modern%20data%20analytics%20displays%20showing%20intelligent%20forecasting%20systems%20and%20risk%20management%20dashboards%20in%20sleek%20corporate%20environment%20with%20navy%20blue%20and%20cyan%20accent%20colors%20and%20clean%20minimalist%20design&width=400&height=300&seq=industry2&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      name: 'Professional Services',
      description: 'Advisor augmentation, workflow intelligence, and scalable client management systems.',
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20professional%20services%20workspace%20with%20intelligent%20workflow%20automation%20systems%20and%20client%20management%20technology%20in%20modern%20office%20setting%20with%20clean%20lines%20and%20sophisticated%20blue%20color%20palette%20representing%20business%20consulting%20excellence&width=400&height=300&seq=industry3&orientation=landscape'
    }
  ];

  return (
    <section id="industries" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-slate-900 leading-tight mb-6">
            Built for High-Trust Industries
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto">
            We specialize in sectors where precision, compliance, and reliability are non-negotiable.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8 mb-12">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-200 cursor-pointer group border border-slate-100"
            >
              <div className="relative w-full h-[300px] overflow-hidden">
                <img 
                  src={industry.image}
                  alt={industry.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-3">
                    <i className={`${industry.icon} text-blue-600 text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-slate-900 mb-4">
                  {industry.name}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="px-8 py-4 border-2 border-slate-900 text-slate-900 rounded-full hover:bg-slate-900 hover:text-white transition-all duration-200 flex items-center gap-2 font-medium cursor-pointer whitespace-nowrap mx-auto">
            See Industry Solutions
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
